/**
 * @fileoverview POSTWS handler for the "/engagement/:app_group_id/canvas/:workflow_id/async_audience_preview" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../../../reactQueryFetcherAdapters";
import { engagementAppGroupIdCanvasWorkflowIdAsyncAudiencePreview } from "./constants";
import type {
  PostwsEngagementAppGroupIdCanvasWorkflowIdAsyncAudiencePreviewPayload,
  PostwsEngagementAppGroupIdCanvasWorkflowIdAsyncAudiencePreviewProps,
} from "./types";
import { isCanvasAudiencePreviewResult } from "./validators";

export const postCanvasAudiencePreview = reactQueryPostWebsocketAdapter(
  engagementAppGroupIdCanvasWorkflowIdAsyncAudiencePreview,
  (
    signal,
    {
      timeout = 180000,
      jobToken,
      estimated,
      appGroupId,
      workflowId,
      isTemplate,
      forceRefresh,
    }: PostwsEngagementAppGroupIdCanvasWorkflowIdAsyncAudiencePreviewProps
  ): Promise<{}> => {
    const payload: PostwsEngagementAppGroupIdCanvasWorkflowIdAsyncAudiencePreviewPayload = {
      timeout,
      job_token: jobToken,
      estimated,
      is_template: isTemplate,
    };

    return fetch(`/engagement/${appGroupId}/canvas/${workflowId}/async_audience_preview`, "POST", payload, {
      signal,
      headers: { "Force-Cache-Refresh": forceRefresh },
    });
  },
  isCanvasAudiencePreviewResult
);
